export const LOCALIZATION_MODE_LIDAR = 1
export const LOCALIZATION_MODE_GNSS = 2

export function isSetPoseButtonVisible(localizationMode: number | undefined, laserscanActive: boolean): boolean {
  return localizationMode === LOCALIZATION_MODE_GNSS || laserscanActive
}

export function isSetPoseButtonDisabled(localizationMode: number | undefined, hasLidarMap: boolean): boolean {
  if (localizationMode === LOCALIZATION_MODE_GNSS) return false
  return !hasLidarMap
}

export function isSetPoseCardVisible(
  setPoseMode: boolean,
  localizationMode: number | undefined,
  laserscanActive: boolean
): boolean {
  return setPoseMode && isSetPoseButtonVisible(localizationMode, laserscanActive)
}
